module.exports = __webpack_public_path__ + "static/media/HomeWayDirect_v2.cc238d5d.jpg";